module.exports = __webpack_public_path__ + "static/media/HOO-BUSD.b21d7f1c.svg";